import { useMemo } from "react";
import { Button, Tooltip, Text } from "@merge-api/merge-javascript-shared";
import { JSONObjectSchema, SchemaTypes, BlueprintOperationType } from "../../../models/Blueprints";
import useBlueprintContext from "../context/useBlueprintContext";
import BlueprintValidationEditorCard from "./BlueprintValidationEditorCard";
import { buildValidationActions } from "./BlueprintValidationEditorUtils";

type Props = {
  schema: JSONObjectSchema;
  schemaType: SchemaTypes;
  operationType: undefined | string;
};

const BlueprintValidationEditor = ({ schema, schemaType, operationType }: Props) => {
  const {
    setBlueprintParameterSchemaValue,
    setBlueprintReturnSchemaValue,
    setRequiredFieldsForObject,
  } = useBlueprintContext();
  const schemaSetter =
    schemaType === SchemaTypes.parameter_schema
      ? setBlueprintParameterSchemaValue
      : setBlueprintReturnSchemaValue;
  const validationActions = useMemo(
    () => buildValidationActions({ setRequiredFieldsForObject, schemaSetter }),
    [schemaSetter, setRequiredFieldsForObject]
  );
  const title =
    operationType !== BlueprintOperationType.FUNCTIONAL
      ? "Field validation (WIP)"
      : schemaType === SchemaTypes.parameter_schema
      ? "Parameter schema"
      : "Return schema";
  return (
    <div className="p-16 flex-grow overflow-scroll">
      <div className="w-full sticky top-0 h-10 flex items-center bg-white z-10">
        <div className="w-full flex items-center justify-between">
          <Text variant="h3">{title}</Text>
          <Tooltip title="For now, edit the BP's parameter schema in CMS to add custom requirements. Make sure to follow proper JSON schema. See Freshdesk Ticket for example.">
            {/* Mark button as disabled since it doesn't do anything right now */}
            <Button disabled>Add custom requirements</Button>
          </Tooltip>
        </div>
      </div>
      <div className="mt-10 w-full flex items-center flex-grow">
        {schema && Object.entries(schema).length > 0 ? (
          <BlueprintValidationEditorCard
            schema={schema}
            schemaType={schemaType}
            validationActions={validationActions}
            operationType={operationType}
          />
        ) : (
          <Text variant="h6" className="text-gray-40">
            No parameter schema defined for this Blueprint
          </Text>
        )}
      </div>
    </div>
  );
};

export default BlueprintValidationEditor;
